//https://www.npmjs.com/package/quill-resize-module
import { ImageDrop } from "quill-image-drop-module";
import QuillResize from "quill-resize-module";
import * as QuillTableUI from "quill-table-ui";
import React, { useImperativeHandle, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
const TextEditors = (props, ref) => {
	const [docPost, setDocPost] = useState("");
	const bodyRef = useRef(null);

	useImperativeHandle(ref, () => bodyRef.current);
	console.log("props.docTitle=", props.docTitle);

	return (
		<div className="container">
			<form>
				{props.showInputText ? (
					<div className="form-group">
						<input
							type="text"
							onChange={props.onHandleDocTitleChange}
							placeholder="Subject"
							id="textEditorTitle"
						/>
					</div>
				) : (
					""
				)}
				<div
					className="form-group"
					id={
						props.divErrorMessageId ? props.divErrorMessageId : "textEditorBody"
					}
				>
					<ReactQuill
						modules={TextEditors.modules}
						formats={TextEditors.formats}
						value={props.docBody ? props.docBody : ""}
						theme="snow"
						placeholder="Body"
						onChange={(e) => {
							try {
								props.onHandleDocBodyChange(e);
							} catch (e) {}
						}}
					/>
				</div>
			</form>
		</div>
	);
};
Quill.register(
	{
		"modules/tableUI": QuillTableUI,
	},
	true
);
Quill.register("modules/resize", QuillResize);
Quill.register("modules/imageDrop", ImageDrop);
TextEditors.theme = { theme: "bubble" };
TextEditors.modules = {
	toolbar: {
		container: [
			[{ header: "1" }, { header: "2" }, { font: [] }],
			[{ size: [] }],

			["bold", "italic", "underline", "strike", "blockquote"],
			[{ list: "ordered" }, { list: "bullet" }],
			["link", "image", "video"],
			["clean"],
			[{ color: [] }, { background: [] }],
			["customControl"],
		],
		handlers: {
			customControl: () => {
				console.log("customControl was clicked");
			},
		},
		table: true,
		tableUI: true,
	},

	imageDrop: true, // Make sure to add this!!!
	resize: {
		modules: ["Resize", "DisplaySize"],
	},
};
TextEditors.formats = [
	"header",
	"font",
	"size",
	"bold",
	"italic",
	"underline",
	"strike",
	"blockquote",
	"list",
	"bullet",
	"link",
	"image",
	"color",
];

export default React.forwardRef(TextEditors);
